import React, { useContext, useEffect, useState } from "react";
import { PlayerContext } from "../../context/PlayerContext";
import { useHistory } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Loader from "react-loader-spinner";
import logo from "../../assets/images/new_ss_logo.png";
import playFromStart from "../../assets/images/btnEndReset_icon.svg";
import playFromPrevState from "../../assets/images/btnNext_icon.svg";
import CustomizedIcons from "./CustomizedIcons";
import { SSOContext } from "../../context/SSOContext";
import {
  handleKeyDown,
  setSimState,
  getSimSessionKey,
} from "../../utils/utils";
import { deleteSimSessionById } from "../../services/IndexedDbService";

const PromptPlaySimulation = () => {
  const history = useHistory();
  const {
    setPlayerState,
    simSessionState,
    linkId,
    playerState,
    setSimSessionState,
    setLinkId,
  } = useContext(PlayerContext);
  const userContext = useContext(UserContext);
  const ssoContext = useContext(SSOContext);
  const [isPlayFromStart, setIsPlayFromStart] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handlePopstate = () => {
      history.push("/loading");
    };
    window.addEventListener("popstate", handlePopstate);
  }, []);

  useEffect(() => {
    if (isPlayFromStart === false) {
      let playerStateFromSB = simSessionState?.simSessionData
        ? simSessionState?.simSessionData?.playerState
        : null;
      if (!playerStateFromSB) {
        setSimState(ssoContext, userContext, setPlayerState, setLinkId);
      } else {
        if (ssoContext.accountType == "Higher Ed") {
          playerStateFromSB = {
            ...playerStateFromSB,
            showPreSimFeedbackPage: false,
            showPreSimQR: false,
          };
        } else {
          const showPreSimFeedbackPage =
            playerStateFromSB.showPreSimFeedbackPage;
          const showPreSimQR = playerStateFromSB.showPreSimQR;
          playerStateFromSB =
            showPreSimFeedbackPage || showPreSimQR
              ? {
                  ...playerStateFromSB,
                  showPreSimFeedbackPage: ssoContext.showPreSimFeedbackPage,
                  showPreSimQR: ssoContext.showPreSimQR,
                }
              : playerStateFromSB;
        }
        playerStateFromSB = {
          ...playerStateFromSB,
          showPostSimFeedbackPage: ssoContext.showPostSimFeedbackPage,
          showPostSimQR: ssoContext.showPostSimQR,
        };
        setPlayerState(playerStateFromSB);
      }
      setIsLoading(true);
      setTimeout(() => history.push("/play"), 3000);
    } else if (isPlayFromStart == true) {
      setSimSessionState(null);
      const isHigherEd = ssoContext.accountType == "Higher Ed";
      const restartedPlayerState = {
        ...playerState,
        showPreSimFeedbackPage: isHigherEd
          ? false
          : ssoContext.showPreSimFeedbackPage,
        showPreSimQR: isHigherEd ? false : ssoContext.showPreSimQR,
        showPostSimFeedbackPage: ssoContext.showPostSimFeedbackPage,
        showPostSimQR: ssoContext.showPostSimQR,
      };
      setPlayerState(restartedPlayerState);
      localStorage.setItem(
        "showPreSimFeedbackPage",
        restartedPlayerState.showPreSimFeedbackPage
      );
      localStorage.setItem(
        "showPostSimFeedbackPage",
        restartedPlayerState.showPostSimFeedbackPage
      );
      localStorage.setItem(
        "showPreSimQR",
        restartedPlayerState.showPreSimQR
      );
      localStorage.setItem(
        "showPostSimQR",
        restartedPlayerState.showPostSimQR
      );
      localStorage.setItem("playerState", JSON.stringify(restartedPlayerState));
      const deleteSimSessionData = async () => {
        try {
          await deleteSimSessionById(
            getSimSessionKey(playerState.simId, userContext.user.id, linkId)
          );
          setTimeout(() => history.push("/play"), 100);
          console.debug("Sim Session Data Deleted Successfully");
        } catch (error) {
          console.error("Error deleting sim session data:", error);
        }
      };
      deleteSimSessionData();
    }
  }, [isPlayFromStart]);
  return (
    <>
      {isLoading && (
        <div className="loader">
          <div className="loadMessage">
            <div>
              <img src={logo} style={{ width: 500 }} alt="SchoolSims Logo" />
            </div>
            <h1>Loading Simulation...</h1>
            <Loader type="Bars" color="#272370" height={200} width={200} />
          </div>
        </div>
      )}
      {!isLoading && (
        <div className="loader prompt-bg-color">
          <div className="loadMessage">
            <div>
              <img src={logo} style={{ width: 400 }} alt="SchoolSims Logo" />
            </div>
            <div className="session-popup">
              <p className="text-dark">Open session found</p>
              <div className="d-flex">
                <div className="mr-2">
                  <span
                    onClick={() => {
                      setIsPlayFromStart(true);
                    }}
                    tabIndex={0}
                    onKeyDown={(e) =>
                      handleKeyDown(e, setIsPlayFromStart, true)
                    }
                    aria-label="Play from Start"
                  >
                    <CustomizedIcons
                      src={playFromStart}
                      width={true}
                      title="Play from Start"
                    />
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => {
                      setIsPlayFromStart(false);
                    }}
                    tabIndex={0}
                    onKeyDown={(e) =>
                      handleKeyDown(e, setIsPlayFromStart, false)
                    }
                    aria-label="Play from Previous"
                  >
                    <CustomizedIcons
                      src={playFromPrevState}
                      width={true}
                      title="Play from Previous"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PromptPlaySimulation;
